// Файл render.js

// Весь JSX страницы авторизации:
// разметка формы, блок согласий,
// кнопки и модальные окна

import Button from '../components/Button/Button';
import ConsentPanel from '../components/ConsentPanel';
import Input from '../components/Input';
import { Consent_block } from './consent_block';



const Page_authorization_view = ({
    loading,
    response,
    var_8,
    set_var_8,
    var_10,
    set_var_10,
    auth_lock_remaining,
    show_repeat_password,
    show_button_register,
    is_pd_accepted,
    set_is_pd_accepted,
    is_cookies_accepted,
    set_is_cookies_accepted,
    pd_already_accepted,
    cookies_already_accepted,
    is_pd_policy_open,
    set_is_pd_policy_open,
    is_cookies_policy_open,
    set_is_cookies_policy_open,
    phone_ref,
    password_ref,
    image_house,
    show_field_repeat_password,
    page_load_mobile_version,
    revoke_pd_consent,
    revoke_cookies_consent,
    going_after_authorization,
}) => {
    return (
        <div className="page_authorization">
            <div className="auth-pd-side">
                <Consent_block
                    id_suffix="side"
                    pd_already_accepted={pd_already_accepted}
                    cookies_already_accepted={cookies_already_accepted}
                    is_pd_accepted={is_pd_accepted}
                    set_is_pd_accepted={set_is_pd_accepted}
                    is_cookies_accepted={is_cookies_accepted}
                    set_is_cookies_accepted={set_is_cookies_accepted}
                    revoke_pd_consent={revoke_pd_consent}
                    revoke_cookies_consent={revoke_cookies_consent}
                    set_is_pd_policy_open={set_is_pd_policy_open}
                    set_is_cookies_policy_open={set_is_cookies_policy_open}
                />
            </div>

            <div className="authorization-brand">
                <p align="center" className="authorization-logo-row">
                    <img
                        src={image_house}
                        alt="Жилой дом"
                        className="authorization-logo"
                    />
                </p>

                <div className="authorization-title-group">
                    <p align="center" className="authorization-title-row">
                        <label className="label_info_3">Личный кабинет</label>
                    </p>

                    <p
                        align="center"
                        className={
                            'authorization-title-row '
                            + 'authorization-company-title-row'
                        }
                    >
                        <label className="label_info_3">
                            Управляющей компании
                        </label>
                    </p>
                </div>
            </div>

            <form id="form_authorization" onSubmit={going_after_authorization}>
                <p align="center">
                    <Input
                        ref={phone_ref}
                        id="var_8"
                        name="var_8"
                        className="window_settings-control_Phone"
                        type="text"
                        value={var_8}
                        placeholder="+7(___)___-__-__"
                        onChange={(e) => set_var_8(e.target.value)}
                        onInput={(e) => {
                            let v = e.target.value.replace(
                                /\D/g, '').slice(0, 11);
                                
                            if (v.startsWith('8'))
                                v = '7' + v.slice(1);
                            
                            if (!v.startsWith('7') && v.length > 0)
                                v = '7' + v;

                            let r = '';
                            if (v.length > 0)
                                r = '+' + v[0];
                            
                            if (v.length > 1)
                                r += '(' + v.slice(1, 4);
                            
                            if (v.length > 4)
                                r += ')' + v.slice(4, 7);
                            
                            if (v.length > 7)
                                r += '-' + v.slice(7, 9);
                            
                            if (v.length > 9)
                                r += '-' + v.slice(9, 11);

                            e.target.value = r;
                        }}
                    />

                    <br />

                    <Input
                        ref={password_ref}
                        type="password"
                        name="var_10"
                        id="var_10"
                        autoComplete="current-password"
                        placeholder="Пароль"
                        value={var_10}
                        onChange={(e) => set_var_10(e.target.value)}
                    />
                </p>

                <div className="auth-actions-row">
                    <Button
                        id="button_login"
                        type="submit"
                        variant="primary"
                        ariaLabel="Войти"
                        disabled={
                            !is_pd_accepted
                            || loading
                            || auth_lock_remaining > 0
                        }
                    >
                        {auth_lock_remaining > 0
                            ? (
                                `Блокировка ${Math.ceil(
                                    auth_lock_remaining / 60
                                )} мин`
                            )
                            : 'Войти'}
                    </Button>

                    {show_button_register && (
                        <Button
                            id="button_register"
                            type="button"
                            variant="primary"
                            className="Регистрация"
                            ariaLabel="Зарегистрироваться"
                            clickAction={show_field_repeat_password}
                        >
                            Зарегистрироваться
                        </Button>
                    )}
                </div>

            </form>

            <form id="form_download" onSubmit={page_load_mobile_version}>
                <p align="center">
                    <Button
                        id="button_load"
                        type="submit"
                        variant="primary"
                        ariaLabel="Скачать мобильную версию"
                    >
                        Скачать мобильную версию
                    </Button>
                </p>
            </form>

            <div className="auth-pd-inline">
                <Consent_block
                    id_suffix="inline"
                    pd_already_accepted={pd_already_accepted}
                    cookies_already_accepted={cookies_already_accepted}
                    is_pd_accepted={is_pd_accepted}
                    set_is_pd_accepted={set_is_pd_accepted}
                    is_cookies_accepted={is_cookies_accepted}
                    set_is_cookies_accepted={set_is_cookies_accepted}
                    revoke_pd_consent={revoke_pd_consent}
                    revoke_cookies_consent={revoke_cookies_consent}
                    set_is_pd_policy_open={set_is_pd_policy_open}
                    set_is_cookies_policy_open={set_is_cookies_policy_open}
                />
            </div>

            {show_repeat_password && (
                <p align="center" id="label_RepeatPassword">
                    <label>
                        Мы сами создадим Вам личный кабинет, для этого
                        напишите нам на почту:{' '}
                        <a
                            href={
                                'mailto:G1027700484844@yandex.ru'
                                + '?subject=Запрос на создание '
                                + 'личного кабинета'
                                + '&body=Просьба назначить мне пароль'
                                + ' и выслать его ответным сообщением'
                            }
                        >
                            G1027700484844@yandex.ru
                        </a>
                        {' '}В своём сообщении на почте можете написать нам
                        желаемый пароль, его и назначим.
                        Когда получите от нас пароль, введите в
                        соответствующее поле номер своей квартиры и
                        полученный от нас пароль.
                    </label>
                </p>
            )}

            <ConsentPanel
                mode="pd_policy"
                triggerMode="manual"
                isOpen={is_pd_policy_open}
                onClose={() => set_is_pd_policy_open(false)}
                showAcceptButtons={false}
            />

            <ConsentPanel
                mode="cookies"
                triggerMode="manual"
                isOpen={is_cookies_policy_open}
                onClose={() => set_is_cookies_policy_open(false)}
                showAcceptButtons={false}
            />
        </div>
    );
};


export {
    Page_authorization_view,
};
